import styles from './TermLengthCell.module.css';

type TProps = {
  termLengths: string;
};

export const TermLengthCell = ({ termLengths }: TProps) => {
  const renderTermLength = () => {
    return (
      <div>
        {termLengths.split(',').map((term, index) => (
          <span key={`${term}-${index}`} className={styles.termLength}>
            {term}
          </span>
        ))}
      </div>
    );
  };

  return <div data-testid="term-length-cell">{renderTermLength()}</div>;
};
